export default "__VITE_ASSET__vQ9hkvDm__"